import "./App.css";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import Dashboard from "./pages/Dashboard/Dashboard";
import { store } from "./redux/store";
import { Provider } from "react-redux";
import { SnackbarProvider } from "notistack";
import { ThemeProvider, createTheme } from "@mui/material";
import Settings from "./pages/Settings/Settings";
import AuthValidate from "./components/Auth/AuthValidate";
import SettingSideBar from "./pages/Settings/Sidebar";
import ContactEmails from "./pages/Settings/ContactEmails";
import SecuritySettings from "./pages/Settings/Security";
import BalanceSetting from "./pages/Settings/Balance";
import DeveloperSetting from "./pages/Settings/Developer";
import AccountNav from "./components/Settings/AccountNav";
import AccountSetupNav from "./components/Settings/AccountSetupNav";
import AccountSettings from "./pages/Settings/Agency/Account/Account";
import AgencySetupSetting from "./pages/Settings/Agency/AgencySetup.js.js";
import MarkupSetting from "./pages/Settings/Order/Markup/Markup.js";
import CommissionSettings from "./pages/Settings/Agency/Commision";
import PointsSettings from "./pages/Settings/Agency/Points";
import PageNotFound from "./pages/PageNotFound";
import PaymentSetting from "./pages/Settings/Agency/Payment";
import Finance from "./pages/Settings/Finance/Finance";
import FinanceContainer from "./pages/Settings/Finance/FinanceContainer";
import Orders from "./pages/Orders/Orders";
import UserManagement from "./pages/UserManagement/UserManagement";
import Links from "./pages/Links/Links";
import CreateFlightOrder from "./pages/Orders/Flight/CreateFlightOrder";
import OffersList from "./pages/Orders/Flight/FlightSearch/OffersList";
import FlightBook from "./pages/Orders/Flight/Book/FlightBook";
import FlightBookDetails from "./pages/Orders/Flight/Book/FlightBookDetails.js";
import FlightAncillaries from "./pages/Orders/Flight/Book/FlightAncillaries.js";
import Test from "./pages/test.js";
import FlightPayment from "./pages/Orders/Flight/Book/FlightPayment.js";
import FlightOrder from "./pages/Orders/Flight/Booked/FlightOrder.js";
import OrderNav from "./components/Settings/OrderNav.js";
import PayoutMethods from "./pages/Settings/Finance/PayoutMethods.js";
import PaymentGateway from "./pages/Settings/Agency/PaymentGateway.js";
import SupplierSettings from "./pages/Settings/Order/Suppliers/Suppliers.js";
import PromoSettings from "./pages/Settings/Order/PromoCodes/PromoCodes.js";
import EmailTemplateSettings from "./pages/Settings/EmailTemplates/EmailTemplates.js";
import ChangeFlightOrder from "./pages/Orders/Flight/Booked/ChangeOrder/ChangeOrder.js";
import CurrencySetting from "./pages/Settings/Agency/Currency/CurrencySetting.js";
import FAQSetting from "./pages/Settings/FAQ/FAQSetting.js";
import NewOrders from "./pages/Orders/NewOrders.jsx";
import TicketManagementFlightOrderDetail from "./pages/TicketManagement/Flight/TicketManagementFlightOrderDetail.jsx";
import TicketManagementFlightChangeDate from "./pages/TicketManagement/Flight/TicketManagementFlightChangeDate.jsx";
import TicketManagementFlightSearchFlight from "./pages/TicketManagement/Flight/TicketManagementFlightSearchFlight.jsx";
import TicketManagementFlightConfirmation from "./pages/TicketManagement/Flight/TicketManagementFlightConfirmation.jsx";
import TicketManagementFlightChangeInfo from "./pages/TicketManagement/Flight/TicketManagementFlightChangeInfo.jsx";
import TicketManagementFlightRefund from "./pages/TicketManagement/Flight/TicketManagementFlightRefund.jsx";
import TicketManagementFlightVoid from "./pages/TicketManagement/Flight/TicketMangementFlightVoid.jsx";
import TicketManagementFlightAddBag from "./pages/TicketManagement/Flight/TicketManagementFlightAddBag.jsx";
import TicketManagementFlightChangeDateConfirmationDetailsPage from "./pages/TicketManagement/Flight/TicketManagementFlightChangeDateConfirmationDetailsPage.jsx";
import Fees from "./pages/Settings/Finance/Fees.js";
import Subscription from "./pages/Settings/Finance/Subscription.js";
import SupplierContainer from "./pages/Settings/Supplier/SupplierContainer.js";
import Supplier from "./pages/Settings/Supplier/Supplier.js";
import AccountRoles from "./pages/Settings/Roles/AccountRoles.js";
import AdminTeamMembers from "./pages/Settings/AdminTeamMembers.js";
import Transactions from "./pages/Transactions/Transactions.js";
import Tasks from "./pages/Tasks/Tasks.jsx";
import AirlineCommission from "./pages/Settings/Order/AirlineCommission/AirlineCommission.jsx";
import TaxSetting from "./pages/Settings/Order/TaxSetting/TaxSetting.jsx";
import SplitCommission from "./pages/Settings/Order/SplitCommission/SplitCommission.jsx";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import GettingStartedHome from "./pages/GettingStarted/GettingStartedHome.jsx";
import PointsPage from "./pages/points/PointsPage.jsx";
import Academy from "./pages/Settings/Academy/Academy.js";
import Module from "./pages/Settings/Academy/Module.js";
import Videos from "./pages/Settings/Academy/Videos.js";
import Banner from "./pages/Settings/Banner/Banner.jsx";
import TicketManagementFlightRefundConfirmationPage from "./pages/TicketManagement/Flight/TicketManagementFlightRefundConfirmationPage.jsx";
import TicketManagementFlightVoidConfirmationPage from "./pages/TicketManagement/Flight/TicketManagementFlightVoidConfirmationPage.jsx";
import Visa from "./pages/Settings/Order/Visa/Visa.jsx";
import TicketManagementFlightChangeNameConfirmationDetailsPage from "./pages/TicketManagement/Flight/TicketManagementFlightChangeNameConfirmationDetailsPage.jsx";
import Sms from "./pages/Settings/sms/Sms.jsx";
import ReportDashboard from "./pages/ReportDashboard/ReportDashboard.jsx";
import WhitelistDomainPage from "./pages/Settings/Whitelist/WhitelistDomainPage.jsx";
import WorldCup from "./pages/Settings/WorldCup/WorldCup.jsx";
import SettleWorldCup from "./pages/Settings/WorldCup/SettleWorldCup.jsx";
import SubscribtionDashboardLayout from "./components/subscribtionDashboard/layout/SubscribtionDashboardLayout.jsx";
import DashboardOverview from "./pages/subscriptionDashboard/DashboardOverview.jsx";
import Analytics from "./pages/subscriptionDashboard/Analytics.jsx";
import AuditLogs from "./pages/subscriptionDashboard/AuditLogs.jsx";
import BillingTransactions from "./pages/subscriptionDashboard/BillingTransactions.jsx";
import PlansManagement from "./pages/subscriptionDashboard/PlansManagement.jsx";
import AddonsManagement from "./pages/subscriptionDashboard/AddonsManagement.jsx";
import ServiceFeeConfig from "./pages/subscriptionDashboard/ServiceFeeConfig.jsx";
import SettingsScreen from "./pages/subscriptionDashboard/SettingsScreen.jsx";
import TrialsScreen from "./pages/subscriptionDashboard/TrialsScreen.jsx";
import TeamPricingConfig from "./pages/subscriptionDashboard/TeamPricingConfig.jsx";
import UserSubscriptionDetail from "./pages/subscriptionDashboard/UserSubscriptionDetail.jsx";
import UsersScreen from "./pages/subscriptionDashboard/UsersScreen.jsx";
import CreateFlightFee from "./pages/subscriptionDashboard/CreateFlightFee.js";
// import 'dotenv/config'

// const rootElement = document.getElementById("root");

const CustomThemeProvider = ({ children }) => {
  // const themeHook = useTheme();

  // Create a new theme object with the updated primary color
  const theme = createTheme({
    palette: {
      primary: {
        main: "#0067FF",
      },
      // secondary: {
      //   main: '#1E61DC',
      // },
      // primaryLight: {
      //   main: themeColor ? themeColor+'aa' : "#3a3"
      // }
    },
    // components: {
    //   MuiPopover: {
    //     defaultProps: {
    //       container: rootElement,
    //     },
    //   },
    //   MuiPopper: {
    //     defaultProps: {
    //       container: rootElement,
    //     },
    //   },
    // },
  });

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

function App() {
  return (
    <Router>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <Provider store={store}>
          <CustomThemeProvider>
            <SnackbarProvider
              autoHideDuration={3000}
              maxSnack={3}
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <Routes>
                <Route path="/" element={<AuthValidate />}>
                  <Route path="test" element={<Test />} />
                  {/* <Route path='profile' element={<ProfileSurvey />} /> */}
                  {/* <Route path='/welcome' element={<WelcomeNavbar />} >
                    <Route index element={<ProfileStatusCheck />} />
                    <Route path='support' element={<LearnSupport />} />
                    <Route path='pricing' element={<LearnPricing />} />
                    <Route path='learn' element={<LearnMiles />} />
                  </Route> */}
                  <Route
                    path="subscritionDashboard"
                    element={<SubscribtionDashboardLayout />}
                  >
                    <Route index element={<DashboardOverview />} />
                    <Route path="plans" element={<PlansManagement />} />
                    <Route path="addons" element={<AddonsManagement />} />
                    {/* <Route path="features" element={<FeatureManagement />} /> */}
                    <Route path="trials" element={<TrialsScreen />} />
                    <Route path="service-fees" element={<ServiceFeeConfig />} />
                    <Route
                      path="service-fees/create"
                      element={<CreateFlightFee />}
                    />
                    <Route
                      path="team-pricing"
                      element={<TeamPricingConfig />}
                    />
                    <Route path="users" element={<UsersScreen />} />
                    <Route
                      path="users/:userId"
                      element={<UserSubscriptionDetail />}
                    />
                    <Route path="billing" element={<BillingTransactions />} />
                    <Route path="analytics" element={<Analytics />} />
                    <Route path="settings" element={<SettingsScreen />} />
                    <Route path="audit-logs" element={<AuditLogs />} />
                  </Route>
                  <Route path="/" element={<Navbar />}>
                    <Route path="/" element={<GettingStartedHome />} />

                    <Route path="dashboard" element={<Dashboard />} />
                    <Route
                      path="reportDashboard"
                      element={<ReportDashboard />}
                    />
                    <Route path="tasks" element={<Tasks />} />
                    <Route path="points" element={<PointsPage />} />
                    <Route path="order">
                      <Route index element={<NewOrders />} />
                      <Route
                        path="new/:order"
                        element={<CreateFlightOrder />}
                      />
                      <Route
                        path="neworder"
                        element={<Orders />}
                        // element={<CreateFlightOrder />}
                      />
                      <Route
                        path="new/flight/offers"
                        element={<OffersList />}
                      />
                      <Route
                        path="new/flight/book/:id"
                        element={<FlightBook />}
                      />
                      <Route
                        path="new/flight/book/details/:id"
                        element={<FlightBookDetails />}
                      />
                      <Route
                        path="new/flight/book/ancillaries/:id"
                        element={<FlightAncillaries />}
                      />
                      <Route
                        path="new/flight/book/payment/:id"
                        element={<FlightPayment />}
                      />
                      <Route path="flight/:id" element={<FlightOrder />} />
                      <Route
                        path="flight/change/:id"
                        element={<ChangeFlightOrder />}
                      />
                      <Route
                        path="flight/ticket/detail/:id"
                        element={<TicketManagementFlightOrderDetail />}
                      />
                      <Route
                        path="flight/ticket/changedate/confirmation/:id"
                        element={
                          <TicketManagementFlightChangeDateConfirmationDetailsPage />
                        }
                      />
                      <Route
                        path="flight/ticket/rename/confirmation/:id"
                        element={
                          <TicketManagementFlightChangeNameConfirmationDetailsPage />
                        }
                      />
                      <Route
                        path="flight/ticket/refund/confirmation/:id"
                        element={
                          <TicketManagementFlightRefundConfirmationPage />
                        }
                      />
                      <Route
                        path="flight/ticket/void/confirmation/:id"
                        element={<TicketManagementFlightVoidConfirmationPage />}
                      />
                      <Route
                        path="flight/ticket/changedate/:id"
                        element={<TicketManagementFlightChangeDate />}
                      />
                      <Route
                        path="flight/ticket/searchflight/:id"
                        element={<TicketManagementFlightSearchFlight />}
                      />
                      <Route
                        path="flight/ticket/confirmation"
                        element={<TicketManagementFlightConfirmation />}
                      />
                      <Route
                        path="flight/ticket/changeinfo/:id"
                        element={<TicketManagementFlightChangeInfo />}
                      />
                      <Route
                        path="flight/ticket/refund/:id"
                        element={<TicketManagementFlightRefund />}
                      />
                      <Route
                        path="flight/ticket/void/:id"
                        element={<TicketManagementFlightVoid />}
                      />
                      <Route
                        path="flight/ticket/addbag"
                        element={<TicketManagementFlightAddBag />}
                      />
                    </Route>
                    <Route path="tasks" element={<Tasks />} />
                    <Route path="whitelist" element={<WhitelistDomainPage />} />
                    <Route path="transactions" element={<Transactions />} />
                    <Route path="users" element={<UserManagement />} />
                    <Route path="link" element={<Links />} />
                    <Route path="*" element={<PageNotFound />} />
                  </Route>
                  <Route path="settings" element={<SettingSideBar />}>
                    <Route path="" element={<AccountNav />}>
                      <Route index element={<AccountSettings />} />
                      <Route path="team" element={<AdminTeamMembers />} />
                      <Route path="roles" element={<AccountRoles />} />
                      <Route path="security" element={<SecuritySettings />} />
                      <Route path="sms" element={<Sms />} />
                      <Route path="*" element={<PageNotFound />} />
                    </Route>
                    <Route path="agency" element={<AccountSetupNav />}>
                      <Route index element={<AgencySetupSetting />} />
                      <Route path="brand" element={<Settings />} />
                      <Route path="contact" element={<ContactEmails />} />
                      <Route path="developer" element={<DeveloperSetting />} />
                      <Route path="*" element={<PageNotFound />} />
                    </Route>
                    <Route path="order" element={<OrderNav />}>
                      <Route index element={<MarkupSetting />} />
                      <Route
                        path="airlineCommission"
                        element={<AirlineCommission />}
                      />
                      <Route
                        path="commission"
                        element={<CommissionSettings />}
                      />
                      <Route path="points" element={<PointsSettings />} />
                      <Route path="suppliers" element={<SupplierSettings />} />
                      <Route path="dealcodes" element={<PromoSettings />} />
                      <Route
                        path="emailTemplates"
                        element={<EmailTemplateSettings />}
                      />
                      <Route path="tax" element={<TaxSetting />} />
                      <Route
                        path="splitCommission"
                        element={<SplitCommission />}
                      />
                      <Route path="visa" element={<Visa />} />
                      <Route path="*" element={<PageNotFound />} />
                    </Route>
                    <Route path="supplier" element={<SupplierContainer />}>
                      <Route index element={<Supplier />} />
                      <Route path="*" element={<PageNotFound />} />
                    </Route>
                    <Route path="finance" element={<FinanceContainer />}>
                      <Route index element={<Finance />} />
                      <Route path="method" element={<PayoutMethods />} />
                      <Route path="balance" element={<BalanceSetting />} />
                      <Route path="payment" element={<PaymentSetting />} />
                      <Route path="gateway" element={<PaymentGateway />} />
                      <Route path="currency" element={<CurrencySetting />} />
                      <Route path="*" element={<PageNotFound />} />
                      <Route path="fees" element={<Fees />} />
                      <Route path="subscription" element={<Subscription />} />
                    </Route>
                    <Route path="faq" element={<FAQSetting />} />
                    <Route path="academy" element={<Academy />} />
                    <Route path="academy/module" element={<Module />} />
                    <Route path="academy/module/videos" element={<Videos />} />
                    <Route path="banner" element={<Banner />} />
                    <Route path="world-cup" element={<WorldCup />} />
                    <Route
                      path="world-cup/settle/:gameId"
                      element={<SettleWorldCup />}
                    />
                  </Route>
                </Route>
              </Routes>
            </SnackbarProvider>
          </CustomThemeProvider>
        </Provider>
      </LocalizationProvider>
    </Router>
  );
}

export default App;
